<!-- <div class="authentification">
    <div class="home">
        <a routerLink="/">
            <div class="icon-home">
                <i class="glyphicon glyphicon-home"></i>
            </div>
            <span>Home</span>
        </a>
    </div>
    <div class="auth-content">
            <router-outlet></router-outlet>
    </div>
</div> -->
<div class="home">
    <a routerLink="/">
        <div class="icon-home">
            <i class="glyphicon glyphicon-home"></i>
        </div>
        <span>Home</span>
    </a>
</div>
<div class="container">
    <div class="text-center logo">
        <img src="assets/images/logo1.png" alt="logo" width="400px">
    </div>
    <router-outlet></router-outlet>
</div>